/* eslint-disable react/jsx-no-target-blank */
import { Link } from "react-router-dom";
import { useState } from "react";
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
Modal.setAppElement('#root');

export default function Einverstaendnis(props) {
  const [danke, setDanke] = useState(false);
  const [user,setUser] = useState();
  const [beuser, setbeuser] = useState();
  const [wishes, setWishes] = useState();
  const [ticketId, setTicketId] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      "text-align": 'center'
    }
  };
  const handleCheck = (e) => {
    props.setEinverstaendnis(
      Object.assign({}, props.einverstaendnis, {
        [e.target.name]: !props.einverstaendnis[e.target.name],
      })
    );
  };

  const sendWishes = () => {
    return new Promise((resolve,reject) => {
      let requser = {
        referredby: props.referrer,
        prename: props.prename,
        givenname: props.surname,
        mailaddress: props.email,
        want_newsletter: props.einverstaendnis?.newsletter
      };
      console.log(requser);
      setUser(requser);
      fetch('/cust/newticket', {
        method: 'POST', 
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(requser)
      })
      .then(response => response.json()).then(data => {
        setbeuser(data);
        console.log(data);
        let wishes = {
          referred_by: null,
          cust_id: data.id,
          wishes: props.anliegen?.anderes_field,
          referredby: props.referrer,
          affiliate: props.referrer,
          risiken: props.anliegen?.sachversicherung,
          krankheit: props.anliegen?.krankenpflege,
          alter: props.anliegen?.altersvorsorge,
          vermoegen: props.anliegen?.vermoegensbildung,
          nachhaltigkeit: props.anliegen?.wertpapiere,
          verdeKnow: props.anliegen.know_verde
        };
        setWishes(wishes);
        console.log("Sending wishes", wishes);
        fetch('/cust/wishes', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify(wishes)})
        .then(response => response.json()).then(data => {setTicketId(data.shortId); resolve(data.shortId); }).catch(console.error);
      }).catch(console.error);  
    })
    };

    const handleFinalize = () => {
      setIsOpen(true);
      sendWishes()
      .then(ticketid_fetched => {
        fetch('/cust/finalize?tid='+ticketid_fetched).then(response => {setIsOpen(false); setDanke(true)}).catch(console.error);
      })
    }
  return (
    <>
    <Modal
      isOpen={modalIsOpen}
      style={customStyles}
      contentLabel="Führe Buchung aus">
      <h1>Buchung wird ausgeführt...</h1>
      <div style={{'margin-top': '25px'}}><Loader type="Oval" color="#822bae" height={50} width={50}/></div>
    </Modal>
    { !danke &&
    <div id="einverstaendnis">
      <h2>Fast geschafft. Wir benötigen nur noch Dein Einverständnis.</h2>
      <div className="ccontent">
        <ul>
          <li>
            <label>
              <input
                type="checkbox"
                name="datenschutz_accept"
                onClick={(e) => handleCheck(e)}
              />
              <span className="licontent">
                Mit Deiner Buchung erklärst Du Dich mit den Bedingungen und den{" "}
                <a
                  href="https://check.ver.de/datenschutz/"
                  target="_blank"
                  rel="noopener, nofollow"
                >
                  Datenschutzbestimmungen
                </a>{" "}
                von ver.de einverstanden.
              </span>
            </label>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                name="weitergabe_accept"
                onClick={(e) => handleCheck(e)}
              />
              <span className="licontent">
                Mir ist bekannt, dass meine Daten im Rahmen der Terminvermittlung
                zum Zwecke der Terminvereinbarung an eine*n Berater*in übermittelt
                werden, und stimme dem ausdrücklich zu.
              </span>
            </label>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                name="widerruf_accept"
                onClick={(e) => handleCheck(e)}
              />
              <span className="licontent">
                Die{" "}
                <a
                  href="https://check.ver.de/widerruf/"
                  target="_blank"
                  rel="noopener, nofollow"
                >
                  Widerrufsbelehrung
                </a>{" "}
                habe ich zur Kenntnis genommen.
              </span>
            </label>
          </li>
          <li>
            <label>
              <input
                type="checkbox"
                name="newsletter"
                onClick={(e) => handleCheck(e)}
              />
              <span className="licontent">
                Ich möchte gleich auch den ver.de-Newsletter abonnieren.
              </span>
            </label>
          </li>
        </ul>
        {props.einverstaendnis?.datenschutz_accept &&
          props.einverstaendnis?.weitergabe_accept &&
          props.einverstaendnis?.widerruf_accept && (
            <Link onClick={() => handleFinalize()} className="ui button">Für 45€ kostenpflichtig bestellen</Link>
          )}
        {(!props.einverstaendnis?.datenschutz_accept ||
          !props.einverstaendnis?.weitergabe_accept ||
          !props.einverstaendnis?.widerruf_accept) && (
          <Link className="ui button disabled">Für 45€ kostenpflichtig bestellen</Link>
        )}
      </div> 
    </div>
    }
      { danke &&
      <>
        <h1>Danke für Deine Bestellung, {props.prename}!</h1>
        <p>Wir haben Dir an {props.email} eine E-Mail mit der Rechnung geschickt. Dort findest Du auch einen Link, mit dem Du die Zahlung vornehmen kannst.</p>
        <p>Was möchtest Du weiter tun?</p>
        <div className="outlinks">
          <nobr><a href="https://bike.ver.de">Zur&nbsp;Fahrradabsicherung</a></nobr>{' '}
          <nobr><a href="https://bond.ver.de">Zu&nbsp;den&nbsp;Genussrechten</a></nobr>{' '}
          <nobr><a href="https://blog.ver.de">Zum&nbsp;Blog</a></nobr>{' '}
          <nobr><a href="https://shop.ver.de">Zum&nbsp;Shop</a></nobr>{' '}
          <nobr><a href="https://geno.ver.de">Zur&nbsp;Mitgliedschaft</a></nobr>{' '}
          <nobr><a href="https://www.ver.de">Zur&nbsp;Startseite</a></nobr>{' '}
          <nobr><a href="https://www.ver.de/kapitalanlage">Zur Kapitalanlage von ver.de</a></nobr>{' '}
          <nobr><a href="https://www.ver.de/kontakt">Zum Kontakt</a></nobr>
        </div>
      </>
      }
    </>
  );
}
